<template>
  <div :class="[$style.wrap, fullScreen && $style.fullScreen]">
    <header>
      <span>{{ affiche_info.title }}</span>
    </header>
    <main>
      <p>{{ affiche_info.text }}</p>
      <div :class="$style.btnWrap">
        <button :class="$style.btn" @click="turnoff">{{ btnText }}</button>
      </div>
    </main>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import isFullScreen from '@/libs/business/fullScreen'

export default {
  name: "",
  props: ["afficheData", 'isUseKsSdk'],
  data() {
    return {
      fullScreen: '',
      fanhuiIcon: `${this.$cdnLink}/wanXin/orangeTheme/fanhui.png`,
      btnText: '前往登录'
    };
  },
  created() {
    this.fullScreen = isFullScreen();
  },
  mounted() {
    if (this.isUseKs) {
      this.btnText = '登录赢好礼'
    } else if (this.affiche_info.login_state == 0) {
      this.btnText = '前往游戏'
    }
  },
  computed: {
    ...mapState({
      affiche_info: state => state.user.affiche_info
    }),
    isUseKs() {
      return this.isUseKsSdk == 'true' || this.isUseKsSdk == true
    }
  },
  methods: {
    turnoff() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" module>
@import "../../../assets/css/common.scss";

.wrap {
  position: relative;
  @include common-window();
  > header {
    position: relative;
    > span {
      font-weight: 600;
      font-style: italic;
    }
    .fanhui {
      position: absolute;
      top: 0.35rem;
      right: 0.35rem;
      width: 0.34rem;
      height: 0.25rem;
    }
  }
  > main {
    padding: 0.38rem 0.24rem {
      bottom: 2rem;
    };
    overflow-y: auto;
    word-wrap: break-word; // 只对英文起作用，以单词作为换行依据。
    white-space: pre-wrap;
    .btnWrap {
      display: inline-block;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 6.05rem;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      padding: .1rem 0;
      background: #FFFFFF;
      .btn {
        @include common-button();
        width: 3rem;
      }
    }
  }
  &.fullScreen {
    @include full-screen-window();
    > header {
      position: relative;
      > span {
        font-weight: 600;
        font-style: italic;
      }
      .fanhui {
        position: absolute;
        top: 17px;
        right: 17px;
        width: 17px;
        height: 12px;
      }
    }
    > main {
      padding: 19px 12px {
        bottom: 100px;
      };
      overflow-y: auto;
      word-wrap: break-word; // 只对英文起作用，以单词作为换行依据。
      white-space: pre-wrap;
      .btnWrap {
        display: inline-block;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 302px;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        padding: 4px 0;
        background: #FFFFFF;
        .btn {
          @include full-screen-button();
          width: 150px;
          height: 35px;
        }
      }
    }
  }
}
</style>